import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type ThemeMode } from '../../lib/theme';
import { cn } from '../../lib/utils';

const OPTIONS: { mode: ThemeMode; icon: typeof Sun; label: string }[] = [
  { mode: 'light', icon: Sun, label: 'Light' },
  { mode: 'dark', icon: Moon, label: 'Dark' },
  { mode: 'system', icon: Monitor, label: 'Device' },
];

export function ThemeToggle({ className }: { className?: string }) {
  const { mode, setMode } = useTheme();

  return (
    <div className={cn('flex items-center gap-0.5 p-0.5 rounded-lg bg-surface-muted', className)}>
      {OPTIONS.map(({ mode: m, icon: Icon, label }) => (
        <button
          key={m}
          type="button"
          onClick={() => setMode(m)}
          title={label}
          aria-label={label}
          aria-pressed={mode === m}
          className={cn(
            'flex flex-1 items-center justify-center h-6 rounded-md transition-colors',
            mode === m
              ? 'bg-card text-accent shadow-sm'
              : 'text-ink-faint hover:text-ink-secondary',
          )}
        >
          <Icon size={13} />
        </button>
      ))}
    </div>
  );
}
